import timezones from './timezones.json'
import {JETMS} from "@jet/jetms-client-sdk/dist/window"

export const SET_TENANT = 'system/SET_TENANT'
export const SET_TIMEZONES = 'system/SET_TIMEZONES'

export const setTenant = (tenant) => {
  return dispatch => {
    dispatch({
      type: SET_TENANT,
      tenant: tenant
    })
    window.localStorage.setItem("tenant", tenant)
    let targetTenant = (typeof JETMS !== "undefined") ? JETMS.activeCountry.code : tenant;
    dispatch({
      type: SET_TIMEZONES,
      timezones: timezones[targetTenant.toLowerCase()].timezones
    })
    window.localStorage.setItem("timezones", JSON.stringify(timezones[targetTenant.toLowerCase()].timezones))
  }
}

export const getDefaultTimezone = (state) => {
  return state.system && state.system.timeZones && state.system.timeZones.length > 0 ? state.system.timeZones[0] : "ETC/UTC"
}


// WEBPACK FOOTER //
// ./src/actions/system.js